import { FC, memo } from 'react';
import { Helmet } from '@dr.pogodin/react-helmet';

import { SEOHeadProps } from './types/SEOHeadProps';

const SEOHeadComponent: FC<SEOHeadProps> = ({
  children,
  title,
  description,
}) => {
  if (!title) return null;

  return (
    <Helmet>
      <title>{title}</title>
      {/* NB: you cannot render Fragment/<></> inside a Helmet */}
      {description && <meta content={description} name="description" />}
      {description && <meta content={description} property="og:description" />}
      {children}
    </Helmet>
  );
};

export const SEOHead = memo(SEOHeadComponent);
